// Initialize pages lookup dictionary as a function to ensure all dependencies are loaded
const initializePagesLookupDictionary = () => {
  return {
    propertyPage: {
      regex: /^\/properties\/([A-Za-z0-9]+)\/edit$/,
      action: onPropertyPageMatch,
    },
    invoicePage: {
      regex: /^\/invoice\/edit\/[A-Za-z0-9]+$/,
      action: onInvoicePageMatch,
    },
    // Document view/editor: URL stays e.g. /documents/20749815 when opening edit overlay (no /edit segment).
    documentEditorPage: {
      regex: /^\/documents\/[A-Za-z0-9]+\/?$/,
      action: onDocumentEditorPageMatch,
    },
    /* Enable the audit mode feature by uncommenting this
    onAccountBalancesPageMatchAdvisoryCouncil: {
      regex: /^\/dashboard\/account-sheet\/property\/[A-Za-z0-9]+\/account\/[^/]+$/,
      action: onAccountBalancesPageMatch,
    },
    onAccountBalancesPagePropertyMatch: {
      regex: /^\/account-balances\/[A-Za-z0-9]+$/,
      action: onAccountBalancesPagePropertyMatch,
    },
    onAccountBalanceInvoicePageMatchAdvisoryCouncil: {
      regex: /^\/dashboard\/account-sheet\/property\/[A-Za-z0-9]+\/account\/[^/]+\/documents\/view/,
      action: onAccountBalanceInvoicePageMatch,
    },
    onAccountBalanceInvoicePageMatchAdministrator: {
      regex: /^\/account-balances\/[A-Za-z0-9]+\/account\/[^/]+\/invoice\/edit/,
      action: onAccountBalanceInvoicePageMatch,
    },
    onAccountBalancesOverviewPageMatch: {
      regex: /^\/dashboard\/account-sheet\/property\/[^/]+$/,
      action: onAccountBalancesOverviewPageMatch,
    },*/
    // Bulk revert button requires this route to be active
    // Also includes Vince's audit mode feature which is disabled for now
    onAccountBalancesPageMatchAdministrator: {
      regex: /^\/account-balances\/[A-Za-z0-9]+\/account\/[^/]+$/,
      action: onAccountBalancesPageMatch,
    },
    paymentsPage: {
      regex: /^\/payments\/invoice\/[A-Za-z0-9]+$/,
      action: onInvoicePageMatch,
    },
    invoiceListPage: {
      regex: /invoice/,
      action: onInvoiceListPageMatch,
    },
    rentPlanEditPage: {
      regex:
        /^\/properties\/[A-Za-z0-9]+\/edit\/unit\/[A-Za-z0-9]+\/contract\/all\/edit\/[A-Za-z0-9]+\/rent-plan\/[A-Za-z0-9]+\/edit$/,
      action: onRentPlanEditPageMatch,
    },
    contractTenantPage: {
      regex: /contract\/all\/(?:create|edit)/,
      action: onContractsPageMatch,
    },
    lettersPage: {
      regex: /letters\/create/,
      action: onLettersPageMatch,
    },
    unitsPage: {
      regex: /^\/properties\/[A-Za-z0-9]+\/edit\/unit\/[A-Za-z0-9]+\/contract\/all\/?$/,
      action: onUnitsPageMatch,
    },
    openBalancesPage: {
      regex: /^\/order-open-balances\/list\/view\/\d+$/,
      action: onOpenBalancesPageMatch,
    },
    opsCostReportEditPage: {
      regex: /^\/ops-cost-reports\/(?:create|(\d+)\/edit)(?:\/.*)?$/,
      action: onOpsCostReportPageMatch,
    },
    resolutionTemplatesAgendaPage: {
      regex: /^\/owners-meeting\/invitation\/edit\/[A-Za-z0-9]+\/agenda-item\/(?:create|[0-9]+)$/,
      action: onAgendaPageMatch,
    },
    resolutionRecordsListPage: {
      regex: /^\/resolution-records\/([A-Za-z0-9]+)\/?$/,
      action: onResolutionRecordsListPageMatch,
    },
    resolutionRecordsEditPage: {
      regex: /^\/resolution-records\/([A-Za-z0-9]+)\/edit\/(\d+)$/,
      action: onResolutionRecordsEditPageMatch,
    },
    ownersMeetingPage: {
      regex: /^\/owners-meeting\/protocol\/(?:edit|view)\/[0-9]+$/,
      action: onOwnersMeetingPageVoting,
    },
    ownersMeetingInvitationPage: {
      regex: /^\/owners-meeting\/invitation\/(?:edit\/[A-Za-z0-9]+|create|view\/[A-Za-z0-9]+)$/,
      action: onOwnersMeetingInvitationPageMatch,
    },
    distributionKeysPage: {
      regex: /^\/distribution-keys\/([A-Za-z0-9]+)\/(\d{4})\//,
      action: onDistributionKeysPageMatch,
    },
    contactPage: {
      // Impower uses /persons/view-person/… from Kontakte and /view-person/… (no "persons" segment) from e.g. property > contracts — same form, different pathname
      regex: /^\/(?:persons\/)?view-person\/\d+\/edit-person\/\d+$/,
      action: onContactPageMatch
    },
    // Impower uses /persons/view-person/… from Kontakte and /view-person/… (no "persons" segment) from e.g. property > contracts — same form, different pathname
    personViewPage: {
      regex: /^\/(?:persons\/)?view-person\/\d+$/,
      action: onPersonViewPageMatch
    },
    companyPage: {
      regex: /^\/companies\/view-company\/\d+\/edit-company\/\d+$/,
      action: onCompanyPageMatch
    },
    companyViewPage: {
      regex: /^\/companies\/view-company\/\d+$/,
      action: onCompanyViewPageMatch
    },
    bankTransactionsPage: {
      regex: /^\/bank-transactions\/[0-9]+$/,
      action: onBankTransactionsPageMatch,
    },
    paymentExecutePage: {
      regex: /^\/payments\/execute$/,
      action: onPaymentExecutePageMatch,
    },
    directDebitExecutePage: {
      regex: /^\/direct-debits\/execute$/,
      action: onDirectDebitExecutePageMatch,
    },
    directDebitListPage: {
      regex: /^\/direct-debits\/?$/,
      action: onDirectDebitListPageMatch,
    },
  }
}

// Backward compatibility: expose as global variable 
// This will be available after all files load
window.pagesLookupDictionary = null

// Initialize when DOM is ready and all functions are available
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.pagesLookupDictionary = initializePagesLookupDictionary()
    initializeAiChatWorkspace()
  })
} else {
  window.pagesLookupDictionary = initializePagesLookupDictionary()
  initializeAiChatWorkspace()
}
